import getDates from "./date.service";

const popupNotificationService = {
  getNotification: function (data) {
    return this.createNotificationControlPoint(data);
  },
  createNotificationControlPoint: function (data) {
    return {
      id: data.id,
      title: `Маршрут "${data.routeTitle}" по направлению "${data.tripTitle}" с ${getDates.getDateFormat3(
        data.tripStart
      )} по ${getDates.getDateFormat3(data.tripEnd)}`,
      text: `ТС: ${data.unitTitle} ${data.registerNumber} не прибыл к "${data.controlPointTitle}" ко времени ${getDates.getDateFormat3(
        data.controlPointTime
      )}`,
      level: 3,
    };
  },
};

export default popupNotificationService;
